module.exports = __webpack_public_path__ + "ci.02796bef.svg";